import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberService } from 'src/app/services/member.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-edit-subscription',
  templateUrl: './edit-subscription.component.html',
  styleUrls: ['./edit-subscription.component.scss']
})
export class EditSubscriptionComponent implements OnInit {
  public subscription: any = null;
  public loading = true;
  public saving = false;
  public subUntilDate: any = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _member: MemberService,
    private _notify: NotificationService
  ) {}

  ngOnInit() {
    const id = this._route.snapshot.params['id'];
    this._member.getSubscription(id).subscribe(res => {
      this.subscription = res;
      this.subUntilDate = new Date(res.sub_until);
      this.loading = false;
    });
  }

  submit() {
    if (!this.subUntilDate) {
      this._notify.showMessage('Please select an expiry date', 'OK');
      return;
    }
    this.saving = true;
    const date = this.subUntilDate instanceof Date ? this.subUntilDate : new Date(this.subUntilDate);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const dateStr = `${y}-${m}-${d}`;
    this._member.updateSubscription(this.subscription.id, dateStr).subscribe(
      () => {
        this._notify.showMessage('Subscription updated successfully', 'OK');
        this.saving = false;
        this._router.navigate(['/subscriptions']);
      },
      () => {
        this._notify.showMessage('Error updating subscription', 'OK');
        this.saving = false;
      }
    );
  }
}
